// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__6Picu","signatureBlock":"Footer_signatureBlock__2ds5Q","signature":"Footer_signature__w9ZGt"};